import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@metarouter-private/mr-mui';

import FieldValueView from 'app/audit-logs/AuditLogModal/AuditLogPanel/FieldValueView';

export default function AuditLogKeyValueList({ fields }) {
  return (
    <Stack data-test-id="auditLogKeyValueList" spacing={1} component="dl">
      {fields.map(field => (
        <Stack key={field.key} direction="row" spacing={1} component="div">
          <Typography component="dt" data-test-id="auditLogFieldName" variant="body2">
            {field.label}
          </Typography>
          <Typography component="dd">
            <FieldValueView fieldValue={field.value} complex={field.complex} />
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}

AuditLogKeyValueList.propTypes = {
  fields: PropTypes.array.isRequired,
};
